"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPatientConditionsCustomization = exports.defaultSpecificNeedsCustomization = exports.CustomFieldStateType = void 0;
exports.isUsed = isUsed;
exports.isRequired = isRequired;
exports.getCustomizedTransportReasonLabel = getCustomizedTransportReasonLabel;
exports.useCustomization = useCustomization;
exports.getDepartureMarginInterval = getDepartureMarginInterval;
exports.getArrivalMarginInterval = getArrivalMarginInterval;
var transport_reasons_1 = require("./transport-reasons");
var utils_1 = require("./utils");
exports.CustomFieldStateType = {
    USED: 'USED',
    USED_AND_REQUIRED: 'USED_AND_REQUIRED',
    UNUSED: 'UNUSED',
};
function isUsed(state) {
    return [exports.CustomFieldStateType.USED, exports.CustomFieldStateType.USED_AND_REQUIRED].includes(state);
}
function isRequired(state) {
    return state === exports.CustomFieldStateType.USED_AND_REQUIRED;
}
exports.defaultSpecificNeedsCustomization = [
    {
        vehicleType: 'AMBULANCE',
        fields: [
            { label: 'Fauteuil Roulant', state: exports.CustomFieldStateType.USED },
            { label: 'Isolement protecteur', state: exports.CustomFieldStateType.USED },
            { label: 'Siège enfant', state: exports.CustomFieldStateType.UNUSED },
            { label: 'Oxygène', state: exports.CustomFieldStateType.USED },
            { label: 'Matelas coquille', state: exports.CustomFieldStateType.USED },
            { label: 'Siège bébé', state: exports.CustomFieldStateType.UNUSED },
            { label: 'Incubateur', state: exports.CustomFieldStateType.USED },
        ],
    },
    {
        vehicleType: 'VSL',
        fields: [
            { label: 'Fauteuil Roulant pliable', state: exports.CustomFieldStateType.USED },
            { label: 'Siège enfant', state: exports.CustomFieldStateType.UNUSED },
            { label: 'Siège bébé', state: exports.CustomFieldStateType.UNUSED },
        ],
    },
    {
        vehicleType: 'BARIATRIC',
        fields: [
            { label: 'Fauteuil Roulant', state: exports.CustomFieldStateType.USED },
            { label: 'Isolement protecteur', state: exports.CustomFieldStateType.USED },
            { label: 'Siège enfant', state: exports.CustomFieldStateType.UNUSED },
            { label: 'Oxygène', state: exports.CustomFieldStateType.USED },
            { label: 'Pousse-seringue', state: exports.CustomFieldStateType.USED },
        ],
    },
    {
        vehicleType: 'TPMR',
        fields: [
            { label: 'Fauteuil Roulant', state: exports.CustomFieldStateType.USED },
            { label: 'Siège enfant', state: exports.CustomFieldStateType.UNUSED },
            { label: 'Siège bébé', state: exports.CustomFieldStateType.UNUSED },
        ],
    },
    {
        vehicleType: 'PARAMEDICAL',
        fields: [
            { label: 'Fauteuil Roulant', state: exports.CustomFieldStateType.USED },
            { label: 'Isolement protecteur', state: exports.CustomFieldStateType.USED },
            { label: 'Siège enfant', state: exports.CustomFieldStateType.UNUSED },
            { label: 'Oxygène', state: exports.CustomFieldStateType.USED },
            { label: 'Matelas coquille', state: exports.CustomFieldStateType.USED },
            { label: 'Siège bébé', state: exports.CustomFieldStateType.UNUSED },
            { label: 'Pousse-seringue', state: exports.CustomFieldStateType.USED },
            { label: 'Incubateur', state: exports.CustomFieldStateType.USED },
            { label: 'Scope', state: exports.CustomFieldStateType.USED },
        ],
    },
    {
        vehicleType: 'MEDICAL',
        fields: [
            { label: 'Fauteuil Roulant', state: exports.CustomFieldStateType.USED },
            { label: 'Isolement protecteur', state: exports.CustomFieldStateType.USED },
            { label: 'Siège enfant', state: exports.CustomFieldStateType.UNUSED },
            { label: 'Oxygène', state: exports.CustomFieldStateType.USED },
            { label: 'Matelas coquille', state: exports.CustomFieldStateType.USED },
            { label: 'Siège bébé', state: exports.CustomFieldStateType.UNUSED },
            { label: 'Pousse-seringue', state: exports.CustomFieldStateType.USED },
            { label: 'Incubateur', state: exports.CustomFieldStateType.USED },
            { label: 'Scope', state: exports.CustomFieldStateType.USED },
        ],
    },
];
exports.defaultPatientConditionsCustomization = [
    {
        vehicleType: 'AMBULANCE',
        fields: [
            { label: 'Patient agité', state: exports.CustomFieldStateType.USED },
            { label: 'Gênes ou douleurs', state: exports.CustomFieldStateType.USED },
            { label: 'Surpoids (< 130kg)', state: exports.CustomFieldStateType.USED },
            { label: 'Perfusé', state: exports.CustomFieldStateType.USED },
            { label: 'Contagieux', state: exports.CustomFieldStateType.USED },
            { label: 'Isolement contact', state: exports.CustomFieldStateType.USED },
            { label: 'Prématuré', state: exports.CustomFieldStateType.USED },
            { label: 'Patient désorienté', state: exports.CustomFieldStateType.USED },
        ],
    },
    {
        vehicleType: 'VSL',
        fields: [
            { label: 'Patient agité', state: exports.CustomFieldStateType.USED },
            { label: 'Gênes ou douleurs', state: exports.CustomFieldStateType.USED },
            { label: 'Surpoids (< 130kg)', state: exports.CustomFieldStateType.USED },
            { label: 'Nouveau né / Enfant', state: exports.CustomFieldStateType.UNUSED },
            { label: 'Patient désorienté', state: exports.CustomFieldStateType.USED },
        ],
    },
    {
        vehicleType: 'BARIATRIC',
        fields: [
            { label: 'Patient agité', state: exports.CustomFieldStateType.USED },
            { label: 'Gênes ou douleurs', state: exports.CustomFieldStateType.USED },
            { label: 'Perfusé', state: exports.CustomFieldStateType.USED },
            { label: 'Contagieux', state: exports.CustomFieldStateType.USED },
            { label: 'Patient désorienté', state: exports.CustomFieldStateType.USED },
        ],
    },
    {
        vehicleType: 'TPMR',
        fields: [
            { label: 'Patient agité', state: exports.CustomFieldStateType.USED },
            { label: 'Gênes ou douleurs', state: exports.CustomFieldStateType.USED },
            { label: 'Surpoids (< 130kg)', state: exports.CustomFieldStateType.USED },
            { label: 'Nouveau né / Enfant', state: exports.CustomFieldStateType.UNUSED },
            { label: 'Patient désorienté', state: exports.CustomFieldStateType.USED },
        ],
    },
    {
        vehicleType: 'PARAMEDICAL',
        fields: [
            { label: 'Patient agité', state: exports.CustomFieldStateType.USED },
            { label: 'Gênes ou douleurs', state: exports.CustomFieldStateType.USED },
            { label: 'Surpoids (< 130kg)', state: exports.CustomFieldStateType.USED },
            { label: 'Perfusé', state: exports.CustomFieldStateType.USED },
            { label: 'Contagieux', state: exports.CustomFieldStateType.USED },
            { label: 'Isolement contact', state: exports.CustomFieldStateType.USED },
            { label: 'Prématuré', state: exports.CustomFieldStateType.USED },
            { label: 'Patient désorienté', state: exports.CustomFieldStateType.USED },
        ],
    },
    {
        vehicleType: 'MEDICAL',
        fields: [
            { label: 'Patient agité', state: exports.CustomFieldStateType.USED },
            { label: 'Gênes ou douleurs', state: exports.CustomFieldStateType.USED },
            { label: 'Surpoids (< 130kg)', state: exports.CustomFieldStateType.USED },
            { label: 'Perfusé', state: exports.CustomFieldStateType.USED },
            { label: 'Contagieux', state: exports.CustomFieldStateType.USED },
            { label: 'Isolement contact', state: exports.CustomFieldStateType.USED },
            { label: 'Prématuré', state: exports.CustomFieldStateType.USED },
            { label: 'Patient désorienté', state: exports.CustomFieldStateType.USED },
        ],
    },
];
function getCustomizedTransportReasonLabel(reason, raw, groups) {
    if (groups === void 0) { groups = []; }
    if (raw) {
        return raw;
    }
    // Try to find the label in the MFU customization
    // In case of multi label for the same reason, and raw not set, we take the first.
    for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
        var group = groups_1[_i];
        if (group.transportReasonCustomizations) {
            for (var _a = 0, _b = group.transportReasonCustomizations; _a < _b.length; _a++) {
                var sub = _b[_a];
                if (sub.reason === reason && sub.reason !== 'OTHER') {
                    return sub.label;
                }
            }
        }
    }
    // Fallback to default label
    return transport_reasons_1.reasonRules.getLabel(reason, raw);
}
function useCustomization(_a) {
    var _b = _a === void 0 ? {} : _a, mfu = _b.mfu;
    var transportReasonCustomizationGroups = mfu === null || mfu === void 0 ? void 0 : mfu.transportReasonCustomizationGroups;
    return {
        transportReasonCustomizationGroups: transportReasonCustomizationGroups,
        getCustomizedTransportReasonLabel: function (reason, raw) {
            return getCustomizedTransportReasonLabel(reason, raw, transportReasonCustomizationGroups);
        },
    };
}
function getDepartureMarginInterval(value) {
    switch (value) {
        case 'NONE':
            return [-30, 30];
        case 'PLUS_45':
            return [0, 45];
        case 'PLUS_60':
            return [0, 60];
        case 'PLUS_90':
            return [0, 90];
        case 'PLUS_OR_MINUS_45':
            return [-45, 45];
        case 'PLUS_OR_MINUS_60':
            return [-60, 60];
        case 'PLUS_OR_MINUS_90':
            return [-90, 90];
    }
    (0, utils_1.assertUnreachable)(value);
}
function getArrivalMarginInterval(value) {
    switch (value) {
        case 'NONE':
            return [-30, 0];
        case 'MINUS_45':
            return [-45, 0];
        case 'MINUS_60':
            return [-60, 0];
        case 'MINUS_90':
            return [-90, 0];
    }
    (0, utils_1.assertUnreachable)(value);
}
//# sourceMappingURL=customization.js.map